/* unplugin-vue-components disabled */import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
const _hoisted_3 = {
  cellspacing: "0",
  style: {
    "width": "100%"
  }
};
const _hoisted_4 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_5 = {
  key: 0,
  class: "cell"
};
const _hoisted_6 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_7 = {
  key: 0,
  class: "cell"
};
const _hoisted_8 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_9 = {
  key: 0,
  class: "cell"
};
const _hoisted_10 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_11 = {
  key: 0,
  class: "cell"
};
const _hoisted_12 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_13 = {
  key: 0,
  class: "cell"
};
const _hoisted_14 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_15 = {
  key: 0,
  class: "cell"
};
const _hoisted_16 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_17 = {
  key: 0,
  class: "cell"
};
const _hoisted_18 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_19 = {
  key: 0,
  class: "cell"
};
const _hoisted_20 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_21 = {
  key: 0,
  class: "cell"
};
const _hoisted_22 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_23 = {
  key: 0,
  class: "cell"
};
const _hoisted_24 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_25 = {
  key: 0,
  class: "cell"
};
const _hoisted_26 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_27 = {
  key: 0,
  class: "cell"
};
const _hoisted_28 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
const _hoisted_29 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
import { getCache } from '@/api/monitor/cache';
import * as echarts from 'echarts';
export default {
  __name: 'index',
  setup(__props) {
    const cache = ref([]);
    const commandstats = ref(null);
    const usedmemory = ref(null);
    const {
      proxy
    } = getCurrentInstance();
    function getList() {
      proxy.$modal.loading("正在加载缓存监控数据，请稍候！");
      getCache().then(response => {
        proxy.$modal.closeLoading();
        cache.value = response.data;
        const commandstatsIntance = echarts.init(commandstats.value, "macarons");
        commandstatsIntance.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          series: [{
            name: "命令",
            type: "pie",
            roseType: "radius",
            radius: [15, 95],
            center: ["50%", "38%"],
            data: response.data.commandStats,
            animationEasing: "cubicInOut",
            animationDuration: 1000
          }]
        });
        const usedmemoryInstance = echarts.init(usedmemory.value, "macarons");
        usedmemoryInstance.setOption({
          tooltip: {
            formatter: "{b} <br/>{a} : " + cache.value.info.used_memory_human
          },
          series: [{
            name: "峰值",
            type: "gauge",
            min: 0,
            max: 1000,
            detail: {
              formatter: cache.value.info.used_memory_human
            },
            data: [{
              value: parseFloat(cache.value.info.used_memory_human),
              name: "内存消耗"
            }]
          }]
        });
      });
    }
    getList();
    return (_ctx, _cache) => {
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 24,
          class: "card-box"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("span", null, "基本信息", -1)]))]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("table", _hoisted_3, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[1] || (_cache[1] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "Redis版本")], -1)), _createElementVNode("td", _hoisted_4, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(cache).info.redis_version), 1)) : _createCommentVNode("", true)]), _cache[2] || (_cache[2] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "运行模式")], -1)), _createElementVNode("td", _hoisted_6, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(cache).info.redis_mode == "standalone" ? "单机" : "集群"), 1)) : _createCommentVNode("", true)]), _cache[3] || (_cache[3] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "端口")], -1)), _createElementVNode("td", _hoisted_8, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(cache).info.tcp_port), 1)) : _createCommentVNode("", true)]), _cache[4] || (_cache[4] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "客户端数")], -1)), _createElementVNode("td", _hoisted_10, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(cache).info.connected_clients), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[5] || (_cache[5] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "运行时间(天)")], -1)), _createElementVNode("td", _hoisted_12, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(cache).info.uptime_in_days), 1)) : _createCommentVNode("", true)]), _cache[6] || (_cache[6] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "使用内存")], -1)), _createElementVNode("td", _hoisted_14, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(cache).info.used_memory_human), 1)) : _createCommentVNode("", true)]), _cache[7] || (_cache[7] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "使用CPU")], -1)), _createElementVNode("td", _hoisted_16, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(parseFloat(_unref(cache).info.used_cpu_user_children).toFixed(2)), 1)) : _createCommentVNode("", true)]), _cache[8] || (_cache[8] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "内存配置")], -1)), _createElementVNode("td", _hoisted_18, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(cache).info.maxmemory_human), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[9] || (_cache[9] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "AOF是否开启")], -1)), _createElementVNode("td", _hoisted_20, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(cache).info.aof_enabled == "0" ? "否" : "是"), 1)) : _createCommentVNode("", true)]), _cache[10] || (_cache[10] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "RDB是否成功")], -1)), _createElementVNode("td", _hoisted_22, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(cache).info.rdb_last_bgsave_status), 1)) : _createCommentVNode("", true)]), _cache[11] || (_cache[11] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "Key数量")], -1)), _createElementVNode("td", _hoisted_24, [_unref(cache).dbSize ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(cache).dbSize), 1)) : _createCommentVNode("", true)]), _cache[12] || (_cache[12] = _createElementVNode("td", {
              class: "el-table__cell is-leaf"
            }, [_createElementVNode("div", {
              class: "cell"
            }, "网络入口/出口")], -1)), _createElementVNode("td", _hoisted_26, [_unref(cache).info ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(cache).info.instantaneous_input_kbps) + "kps/" + _toDisplayString(_unref(cache).info.instantaneous_output_kbps) + "kps", 1)) : _createCommentVNode("", true)])])])])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "card-box"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createElementVNode("span", null, "命令统计", -1)]))]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
              ref_key: "commandstats",
              ref: commandstats,
              style: {
                "height": "42rem"
              }
            }, null, 512)])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12,
          class: "card-box"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createElementVNode("span", null, "内存信息", -1)]))]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
              ref_key: "usedmemory",
              ref: usedmemory,
              style: {
                "height": "42rem"
              }
            }, null, 512)])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};